export enum ExecutionStrategy {
  NORMAL,
  FORCE,
}
